import api from '../config/api';
import { ChangeRequest, ChangeRequestStatus } from '../types/changeRequest';

export interface ChangeRequestReviewDto {
  status: ChangeRequestStatus;
  rejectionReason?: string;
}

export const changeRequestService = {
  getMyChangeRequests: async (): Promise<ChangeRequest[]> => {
    const response = await api.get<ChangeRequest[]>('/changerequests');
    return response.data;
  },

  getPendingChangeRequests: async (): Promise<ChangeRequest[]> => {
    const response = await api.get<ChangeRequest[]>('/changerequests/pending');
    return response.data;
  },

  getChangeRequest: async (id: string): Promise<ChangeRequest> => {
    const response = await api.get<ChangeRequest>(`/changerequests/${id}`);
    return response.data;
  },

  approveChangeRequest: async (id: string): Promise<ChangeRequest> => {
    const reviewDto: ChangeRequestReviewDto = {
      status: ChangeRequestStatus.Approved,
    };
    const response = await api.post<ChangeRequest>(
      `/changerequests/${id}/approve`,
      reviewDto
    );
    return response.data;
  },

  rejectChangeRequest: async (
    id: string,
    reason?: string
  ): Promise<ChangeRequest> => {
    const reviewDto: ChangeRequestReviewDto = {
      status: ChangeRequestStatus.Rejected,
      rejectionReason: reason,
    };
    const response = await api.post<ChangeRequest>(
      `/changerequests/${id}/reject`,
      reviewDto
    );
    return response.data;
  },

  approveChangeRequestsBatch: async (ids: string[]): Promise<ChangeRequest[]> => {
    const response = await api.post<ChangeRequest[]>('/changerequests/review-batch', {
      ids,
      status: ChangeRequestStatus.Approved,
    });
    return response.data;
  },

  rejectChangeRequestsBatch: async (
    ids: string[],
    reason: string
  ): Promise<ChangeRequest[]> => {
    const response = await api.post<ChangeRequest[]>('/changerequests/review-batch', {
      ids,
      status: ChangeRequestStatus.Rejected,
      rejectionReason: reason,
    });
    return response.data;
  },
};
